import * as MUTATION from '../mutationTypes';

export default {
  [MUTATION.UPDATE_PACKAGES_LIST](state, data) {
    state.packagesList = data || [];
  },
  [MUTATION.UPDATE_SUBSCRIPTIONS_LIST](state, data) {
    state.subscriptionsList = data || [];
  },
  [MUTATION.UPDATE_ORDERS_LIST](state, data) {
    state.ordersList = Object.values(
        Object.fromEntries(
            [...state.ordersList, ...data].map((order) => [order.id, order]),
        ),
    );
  },
  [MUTATION.UPDATE_PURCHASED_PASSES](state, {data = []} = {}) {
    state.purchasesList = data;
  },
};
